import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { addTransition } from "../../redux/actions/actions";
import { toggleIframe } from "../../redux/actions/model";
import Icon from "../icon/index";
import "./style.scss";
import classNames from "classnames";
import { openModal } from "../../utils";
import { Link } from "react-router-dom";

class PrimaryLink extends Component {
  handleClick(event) {
    event.preventDefault();
    const { isPageTransition, pageTransitionTitle, pageTransitionCurtainColor, pageTransitionCurtainDirection, isShowModal, nestedGrid, link, toggleIframe, addTransition, callback, isDisabled } = this.props;
    if (isDisabled && isDisabled.value) {
      return false;
    }
    if (isShowModal && isShowModal.value) {
      toggleIframe("", nestedGrid.value);
      openModal(link.value.id);
      return false;
    }
    if (isPageTransition && isPageTransition.value) {
      addTransition(
        "page-curtain",
        link && link.value.href,
        pageTransitionTitle && pageTransitionTitle.value,
        (pageTransitionCurtainDirection && pageTransitionCurtainDirection.fields && pageTransitionCurtainDirection.fields.phrase.value === "right-to-left") || false,
        link && link.value.linktype,
        pageTransitionCurtainColor && pageTransitionCurtainColor.fields && pageTransitionCurtainColor.fields.phrase.value
      );
      return;
    }

    if (Object.prototype.toString.call(callback) === "[object Function]") {
      callback(event);
    }
  }

  render() {
    const { isDisabled, colorScheme, iconName, link, id, buttonText, callback } = this.props,
      iconModal = { icon: iconName ? iconName.value : "" };
    const classes = classNames("primary-link", colorScheme && colorScheme.fields && colorScheme.fields.key.value, {
      disabled: (isDisabled && isDisabled.value) || isDisabled === true
    });

    if (link?.value?.href?.startsWith("mailto:tel:")) {
      link.value.href = link.value.href.replace("mailto:tel:", "tel:");
    }

    const innerButtonContent = () => {
      return (
        <span className="primary-link__content" tabIndex="-1">
          <Text tag="span" className="buttonText" field={{ value: buttonText?.value || buttonText || (link && link?.value?.text) }} />
          {iconName && (
            <div className="icon-container">
              <Icon {...iconModal} />
            </div>
          )}
        </span>
      );
    };
    let { linktype, href, target } = link?.value || {};
    if (linktype === "internal") {
      if (callback) {
        return (
          <Link to={href} target={target} className={classes} tabIndex="0" id={id} onClick={callback}>
            {innerButtonContent()}
          </Link>
        );
      }
      return (
        <Link to={href} target={target} className={classes} tabIndex="0" id={id}>
          {innerButtonContent()}
        </Link>
      );
    }

    if (callback) {
      return (
        <button className={classes} onClick={this.handleClick.bind(this)} type="button" tabIndex="0" id={id}>
          {innerButtonContent()}
        </button>
      );
    }

    if (href === "javascript:;return false;" || /^https?:\/\/$/.test(href)) {
      href = null;
    }

    return (
      <a className={classes} href={href} target={target} tabIndex="0" id={id}>
        {innerButtonContent()}
      </a>
    );
  }
}

const mapDispatchToProps = {
  addTransition: addTransition,
  toggleIframe: toggleIframe
};

export default withRouter(connect(null, mapDispatchToProps)(PrimaryLink));
